import { render, staticRenderFns } from "./PolicyResult.vue?vue&type=template&id=60dee9a9&scoped=true&"
import script from "./PolicyResult.vue?vue&type=script&lang=js&"
export * from "./PolicyResult.vue?vue&type=script&lang=js&"
import style0 from "./PolicyResult.vue?vue&type=style&index=0&id=60dee9a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dee9a9",
  null
  
)

export default component.exports